import React from 'react';
import styled from 'styled-components';
import { PageForm } from '../components/Form';
import { HomeHero } from '../components/Home';
import { TopicCard } from '../components/Home/TopicCard';
import { FOOTER_HEIGHT, HEADER_HEIGHT, Layout, Section } from '../components/Layout';
import SEO from '../components/SEO';
import { floralwhite } from '../utils/styles';
import { rhythm } from '../utils/typography';

const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StyledSection = styled(Section)`
  padding: ${rhythm(1)} 0;
  min-height: calc(100vh - ${FOOTER_HEIGHT} - ${HEADER_HEIGHT});
`;

const LastCard = styled(TopicCard)`
  margin-bottom: ${rhythm(4)};
`;

const TopicDescription = styled.p`
  margin: 0;
`;

const Home = () => (
  <Layout>
    <SEO title="Home" />
    <HomeWrapper>
      <StyledSection color={floralwhite}>
        <HomeHero />
        <TopicCard title="Remote Work" url="/remote-work">
          <TopicDescription>Take control of working remotely.</TopicDescription>
        </TopicCard>
        <TopicCard title="Work From Home Gear" url="/remote-work/gear">
          <TopicDescription>Everything you need to work productively and comfortably.</TopicDescription>
        </TopicCard>
        <TopicCard title="Personal Finance • Coming Soon">
          <TopicDescription>Make the most of your money.</TopicDescription>
        </TopicCard>
        <LastCard title="Mindfulness • Coming Soon">
          <TopicDescription>Reduce stress and be happier.</TopicDescription>
        </LastCard>
        <PageForm
          endpoint="topic"
          cta="get advice"
          title="What’s keeping you up at night?"
          subtitle="Whatever that is, there are experienced people who figured it out. We find them and share their lessons with you."
          fields={[
            {
              name: 'topic',
              label: 'I want to',
              type: 'text',
              initialValue: '',
              placeholder: 'Make a wish...',
            },
            {
              name: 'email',
              label: 'Send all the advice to',
              type: 'email',
              initialValue: '',
              placeholder: 'Type your email here...',
            },
          ]}
        />
      </StyledSection>
    </HomeWrapper>
  </Layout>
);

export default Home;
